import { FuseRouteConfigType } from '@fuse/utils/FuseUtils';
import RecordRemovedPage from './RecordRemovedPage';

const RecordRemovedConfig: FuseRouteConfigType = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: null,
	routes: [
		{
			path: 'recover/record-removed',
			element: <RecordRemovedPage />
		}
	]
};

export default RecordRemovedConfig;
